<style scoped>
  .report-btn{
    font-size: 12px;
    text-transform: none;
  }
</style>
<template>
  <v-card
    class="mx-auto"
    flat
    outlined
  >
    <v-layout
      wrap
    >
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-container>
            <v-card-text>
              <v-radio-group v-model="report_id">
                <v-radio
                  v-for="report in reports"
                  :key="report.id"
                  :label="report.text"
                  :value="report.id"
                ></v-radio>
              </v-radio-group>
              <v-textarea v-if="report_id == 4" v-model="report_4_text" outlined></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" text @click="submitReport()" :loading="uploaidng">Submit</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <v-flex xs12 sm4 md2 class="top-border">
        <v-img
          height="130"
          width="130"
          class="my-1 mx-auto"
          :src="item.thumbnailImageUrl"
        ></v-img>
      </v-flex>
      <v-flex xs12 sm8 md7 class="middle-box top-border">
      	<div class="px-1 py-2 middle-box-top">{{item.title}}</div>
      	<v-layout wrap class="middle-box-bottom">
      		<v-flex md4 class=" flex-column middle-box-bottom-1">
      			<a :href="item.amazon_url" target="_blank">Amazon</a>
      			<div v-if="item.quantity > 1">(Pack of {{item.quantity}})</div>
      		</v-flex>
      		<v-flex md3 class="middle-box-bottom-2">
      			<a :href="item.source_url" target="_blank">Walmart</a>
      		</v-flex>
      		<v-flex md5 class="flex-column middle-box-bottom-3" :style="{ backgroundColor: stock_background(item) }">
      			{{item.status}}{{item.aisles}}
      			<div v-if="item.quantity > 1" class="double-check-text">Double check profits due to multipack</div>
      		</v-flex>
      	</v-layout>
      </v-flex>
      <v-flex xs12 sm12 md3 class="px-2 py-2 top-border text-center text-md-left">
    		<div><label class="details-label">Current Rank:</label> {{item.amazon_rank}}</div>
    		<div><label class="details-label">Walmart Price:</label> ${{item.walmart_price}}</div>
    		<div><label class="details-label">Amazon Price:</label> {{item.amazon_price}}</div>
    		<div><label class="details-label">Profit:</label> {{item.profit}} ({{item.roi}})</div>
    		<div><label class="details-label">UPC:</label> {{item.upc}}</div>
        <v-btn color="red" outlined small tile class="report-btn" @click="reportDialog()">Report a problem with item</v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
	props: ['item'],
  data () {
    return {
      dialog: false,
      uploaidng: false,

      report_id: 1,
      reports: [
        {
          id: 1,
          text: 'Price is very wrong',
        },
        {
          id: 2,
          text: 'Rank is very  wrong',
        },
        {
          id: 3,
          text: 'Not taking into account bunding',
        },
        {
          id: 4,
          text: 'Other',
        }
      ],
      report_4_text: ''
    }
  },
  computed: {
  },
  created() {
  },
  watch: {
    dialog(value){
      this.report_id = 1
      this.report_4_text = ''
    }
  },
  methods: {
    stock_background(item){
    	if(item.status == 'In Stock')
    		return '#5cd63559';
    	else if(item.status == 'Limited Stock')
    		return '#d0a711a1';
    	else
    		return '#d0111173';
    },
    reportDialog(){
      this.dialog = true
    },
    submitReport(){
      this.uploaidng = true
      axios.post('/search/master-search/report', {
        report_id: this.report_id,
        report_text: this.report_4_text,
        asin: this.item.asin
      })
      .then(response =>  {
        this.uploaidng = false
        this.dialog = false
      }).catch(error => {
        this.uploaidng = false
        console.log('Error')
      });
    }
  }
};
</script>
